<template>
    <nav class="sidebar-nav sidebar_nav">
      <div class="sidebar_scroll" v-if="showMenu">
        <ul class="nav">
          <li
            :class="{
              'nav-item': true,
              'nav-dropdown': (item.children && item.children.length > 0) || hasMobileSubNav(item),
              'mobile-is-open': isMobileMainNavOpen(item)
            }"
            v-for="(item, index) in listNav"
            :key="index"
            
            :title="
              (item.children && item.children.length > 0) || minisizeMenu === false
                ? ''
                : item.name
            "
            disabled="disabled"
          >
            <a
              :href="item.url"
              @click.stop.prevent="handleNavItemClick(item)"
              v-if="!item.children || item.children.length == 0"
              :class="{
                'nav-link': true,
                'nav-dropdown-toggle': hasMobileSubNav(item),
                'active': checkActiveClass(item)
              }"
            >
              <i :class="`nav-icon ${item.icon}`"></i>
              <span class="name-menu">{{ item.name }}</span>
              <i
                v-if="hasMobileSubNav(item)"
                :class="{
                  'isax-arrow-down-1': true,
                  'mobile-menu-arrow': true,
                  'is-open': isMobileMainNavOpen(item)
                }"
              ></i>
            </a>
            <p
              v-if="item.children && item.children.length > 0"
              class="nav-link nav-dropdown-toggle"
              @click.stop.prevent="handleNavItemClick(item)"
            >
              <i :class="`nav-icon ${item.icon}`"></i>
              <span class="name-menu">{{ item.name }}</span>
              <i
                :class="{
                  'isax-arrow-down-1': true,
                  'mobile-menu-arrow': true,
                  'is-open': isMobileMainNavOpen(item)
                }"
              ></i>
            </p>

            <ul
              v-if="item.children && item.children.length > 0"
              v-show="isSubNavVisible(item)"
              :class="{
                'nav-dropdown-items': true,
                'is-open': isMobileMainNavOpen(item)
              }"
            >
              <li
                v-for="(e, i) in item.children"
                :key="i"
                class="nav-item"
              >
                <!-- :class="path == e.url ? 'nav-link active' : 'nav-link'" -->
                <a
                  :href="e.url || '#'"
                  @click.stop.prevent="goToPage(e.url)"
                  :class="{
                    'nav-link': true,
                    'active': checkActiveClass(e)
                  }"
                >
                  <i :class="`nav-icon ${e.icon}`"></i>
                  <span>{{ e.name }}</span>
                </a>
              </li>
            </ul>
            <ul
              v-if="hasMobileSubNav(item)"
              v-show="isSubNavVisible(item)"
              :class="{
                'mobile-nav-accordion': true,
                'is-open': isMobileMainNavOpen(item)
              }"
            >
              <li
                v-for="(subItem, subIndex) in getCollectionSubNav(item)"
                :key="`mobile-sub-${subIndex}`"
                :class="{
                  'mobile-nav-accordion__item': true,
                  'has-children': subItem.children && subItem.children.length > 0,
                  'is-child-open': isMobileSubItemOpen(subItem)
                }"
              >
                <a
                  :href="subItem.url"
                  @click.stop.prevent="handleMobileSubItemClick(subItem)"
                  :class="{
                    'mobile-nav-accordion__link': true,
                    'active': checkActiveClass(subItem)
                  }"
                >
                  <i :class="`nav-icon ${subItem.icon}`"></i>
                  <span>{{ subItem.name }}</span>
                  <i
                    v-if="subItem.children && subItem.children.length > 0"
                    :class="{
                      'isax-arrow-down-1': true,
                      'mobile-nav-accordion__arrow': true,
                      'is-child-open': isMobileSubItemOpen(subItem)
                    }"
                  ></i>
                </a>
                <ul
                  v-if="subItem.children && subItem.children.length > 0"
                  v-show="isMobileSubItemVisible(subItem)"
                  :class="{
                    'mobile-nav-accordion__children': true,
                    'is-open': isMobileSubItemOpen(subItem)
                  }"
                >
                  <li
                    v-for="(child, childIndex) in subItem.children"
                    :key="`mobile-sub-child-${subIndex}-${childIndex}`"
                  >
                    <a
                      :href="child.url"
                      @click.stop.prevent="goToPage(child.url)"
                      :class="{
                        'mobile-nav-accordion__child-link': true,
                        'active': checkActiveClass(child)
                      }"
                    >
                      <span>{{ child.name }}</span>
                    </a>
                  </li>
                </ul>
              </li>
            </ul>
          </li>
        </ul>
      </div>
      
    </nav>
</template>

<script>
import EventBus from "@/service/EventBus";
import MethodService from "../service/MethodService";
import navTimekeeping from "@/views/nav/_nav-timekeeping";
import navDocumentDrafting from "@/views/nav/_nav-document-drafting";
import navSettings from "@/views/nav/_nav-settings";

const COLLECTION_SUB_NAVS = {
  Timekeeping: navTimekeeping.items,
  DocumentDrafting: navDocumentDrafting.items,
  Setting: navSettings.items,
};

export default {
  props: {
    listNav: {
      type: Array,
      default: () => [],
    },
    minisizeMenu: {
      type: Boolean,
      default: false,
    },
    typeMenu: {
      type: String,
      default: "mainNav",
    },
    mobileSubNav: {
      type: Array,
      default: () => [],
    },
    mobileSubNavCollection: {
      type: String,
      default: "",
    },
    isSystemAdmin: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      path: "",
      collection: "",
      showMenu: true,
      showMenuPreventive: false,
      currentUser: MethodService.getCurrentUser(),
      mobileOpenMenuKey: "",
      openedMobileSubItem: "",
    };
  },
  methods: {
    clickATag(e) {
      e.preventDefault();
    },
    goToPage(url) {
      if (!url || url == "") return;
      this.$router.push({
        path: url,
      }).catch((err) => {});
      this.closeMobileSidebarAfterNavigation();
    },
    getMenuKey(item) {
      if (!item) return "";
      if (item.children && item.children.length > 0) {
        return item.url || item.name;
      }
      if (item.meta && item.meta.collection) {
        return item.meta.collection;
      }
      return item.url || item.name || "";
    },
    hasAnySubNav(item) {
      if (!item) return false;
      if (item.children && item.children.length > 0) return true;
      return this.hasMobileSubNav(item);
    },
    handleNavItemClick(item) {
      if (window.innerWidth < 768 && this.hasAnySubNav(item)) {
        const key = this.getMenuKey(item);
        this.openedMobileSubItem = "";
        this.mobileOpenMenuKey = (this.mobileOpenMenuKey === key) ? "" : key;
        return;
      }
      this.goToPage(item.children && item.children.length > 0 ? "" : item.url);
    },
    handleMobileSubItemClick(item) {
      if (item.children && item.children.length > 0) {
        const key = item.url || item.name;
        this.openedMobileSubItem = (this.openedMobileSubItem === key) ? "" : key;
        return;
      }
      this.goToPage(item.url);
    },
    closeMobileSidebarAfterNavigation() {
      if (window.innerWidth < 768) {
        this.$emit("close-mobile-sidebar");
      }
    },
    getCollectionSubNav(item) {
      if (!item || !item.meta || !item.meta.collection) return [];
      const col = item.meta.collection;
      if (this.mobileSubNavCollection === col && this.mobileSubNav) {
        return this.mobileSubNav;
      }
      return this.filterCollectionSubNav(COLLECTION_SUB_NAVS[col] || []);
    },
    canAccessNavItem(item) {
      if (!item || !item.meta) return false;
      const roles = (this.currentUser && this.currentUser.roles) || [];
      const listFeature = MethodService.getListFeatures() || [];
      const allowAccess = item.meta.allowAccess || [];
      const codes = item.meta.code || [];
      const allowRole = allowAccess.some(role => role === "*" || roles.includes(role));
      const allowFeature = !codes.length || codes.includes("*") || codes.some(code => listFeature.includes(code));
      return allowRole && allowFeature;
    },
    filterCollectionSubNav(items) {
      return MethodService.copyObject(items)
        .filter(item => this.canAccessNavItem(item))
        .map(item => {
          if (item.children && item.children.length > 0) {
            item.children = item.children.filter(child => this.canAccessNavItem(child));
          }
          return item;
        });
    },
    hasMobileSubNav(item) {
      if (!item || (item.children && item.children.length > 0)) return false;
      if (!item.meta || !item.meta.collection) return false;
      const subNav = this.getCollectionSubNav(item);
      return subNav && subNav.length > 0;
    },
    isMobileMainNavOpen(item) {
      if (window.innerWidth >= 768 || !item) return false;
      const key = this.getMenuKey(item);
      return this.mobileOpenMenuKey === key;
    },
    isSubNavVisible(item) {
      if (window.innerWidth >= 768) return true;
      return this.isMobileMainNavOpen(item);
    },
    isMobileSubItemOpen(item) {
      return window.innerWidth < 768 && this.openedMobileSubItem === (item.url || item.name);
    },
    isMobileSubItemVisible(item) {
      if (window.innerWidth >= 768) return true;
      return this.isMobileSubItemOpen(item);
    },
    checkRoute() {
      this.path = this.$router.currentRoute.path;
      this.collection = this.$router.currentRoute.meta.collection;
    },
    checkActiveClass(item) {
      if (this.currentUser.roles.includes("AdminSystem")) {
        return this.$router.currentRoute.path == item.url ? true : false;
      } else {
        if (item.activeurl) {
          return item.activeurl.includes(this.$router.currentRoute.path) ? true : false;
        } else {
          return this.$router.currentRoute.meta.collection == (item.meta && item.meta.collection) ? true : false;
        }
      }
    }
  },
  created() {
    this.checkRoute();
    if (window.innerWidth < 768 && this.mobileSubNavCollection) {
      const currentItem = this.listNav && this.listNav.find(i => i.meta && i.meta.collection === this.mobileSubNavCollection);
      if (currentItem && this.hasAnySubNav(currentItem)) {
        this.mobileOpenMenuKey = this.getMenuKey(currentItem);
      }
    }
    EventBus.$off("ChangeRoute");
    EventBus.$on("ChangeRoute", () => {
      this.checkRoute();
    });
  },
};
</script>

<style lang="scss" scoped>
.name-menu {
  font-family: UTM Avo !important;
  margin-left: 15px;
}
.nav-item:hover {
  cursor: pointer;
}
.sidebar .nav-dropdown-toggle::before {
  width: 13px;
  height: 13px;
  margin-top: -6px;
  background-image: url("/img/arrow.png") !important;
}
.nav-item.nav-dropdown:hover {
  .nav-dropdown-toggle::before {
    transform: rotate(180deg);
  }
}
.mobile-nav-accordion {
  display: none;
}
.mobile-menu-arrow {
  display: none;
}
@media (max-width: 767px) {
  .sidebar .nav-dropdown-toggle::before,
  .nav-dropdown-toggle::before {
    display: none !important;
    content: none !important;
  }

  .mobile-menu-arrow {
    display: inline-block !important;
    margin-left: auto;
    font-size: 12px;
    flex: 0 0 auto;
    transition: transform 0.2s ease-in-out;
    transform: rotate(0deg);
  }

  .mobile-menu-arrow.is-open {
    transform: rotate(180deg) !important;
  }

  .sidebar_nav,
  .sidebar_scroll,
  .nav {
    width: 100%;
    max-width: 100%;
    min-width: 0;
  }

  .sidebar_nav {
    display: flex;
    flex-direction: column;
  }

  .nav {
    display: flex;
    flex-direction: column;
  }

  .nav-item {
    width: 100% !important;
    min-width: 0;
    overflow: visible !important;
  }

  .nav-link {
    width: 100% !important;
    min-height: 48px;
    display: flex !important;
    align-items: center;
    gap: 12px;
    margin: 0;
    padding: 12px 18px !important;
    color: var(--black);
    white-space: normal;
    box-sizing: border-box;
  }

  .nav-link .nav-icon {
    flex: 0 0 28px;
    width: 28px;
    margin: 0;
    text-align: center;
  }

  .nav-link .name-menu,
  .nav-link span {
    display: inline !important;
    min-width: 0;
    margin-left: 0;
    flex: 1 1 auto;
    word-break: normal;
    overflow-wrap: break-word;
  }

  .nav-dropdown-items {
    position: static !important;
    display: none;
    width: 100% !important;
    max-height: none !important;
    margin: 0 !important;
    padding: 4px 0 8px 0 !important;
    box-shadow: none !important;
    border-radius: 0 !important;
    background: transparent !important;
    left: auto !important;
    top: auto !important;
  }

  .nav-dropdown-items.is-open {
    display: block !important;
  }

  .nav-item.nav-dropdown:hover .nav-dropdown-items:not(.is-open) {
    display: none !important;
  }

  .nav-item.mobile-is-open > .nav-dropdown-items {
    display: block !important;
  }

  .nav-dropdown-items .nav-item {
    width: 100% !important;
  }

  .nav-dropdown-items .nav-link,
  .mobile-nav-accordion__link {
    width: 100%;
    min-height: 44px;
    display: flex !important;
    align-items: center;
    gap: 10px;
    padding: 10px 18px 10px 45px !important;
    color: var(--black);
    text-decoration: none;
    box-sizing: border-box;
    box-shadow: none !important;
    border-radius: 0 !important;
    background: transparent;
  }

  .nav-dropdown-items .nav-link.active,
  .mobile-nav-accordion__link.active {
    background: var(--orange_background) !important;
    border-left: 5px solid var(--orange) !important;
    padding-left: 40px !important;
  }

  .mobile-nav-accordion {
    display: none;
    width: 100%;
    margin: 0;
    padding: 4px 0 8px 0;
    list-style: none;
    background: #fff;
    border-top: 1px solid #f1f1f1;
  }

  .mobile-nav-accordion.is-open {
    display: block !important;
  }

  .mobile-nav-accordion__item {
    width: 100%;
  }

  .mobile-nav-accordion__link .nav-icon {
    flex: 0 0 24px;
    width: 24px;
    text-align: center;
  }

  .mobile-nav-accordion__link span,
  .mobile-nav-accordion__child-link span {
    flex: 1 1 auto;
    min-width: 0;
    word-break: normal;
    overflow-wrap: break-word;
  }

  .mobile-nav-accordion__arrow {
    flex: 0 0 auto;
    font-size: 12px;
    transition: transform 0.2s ease-in-out;
    transform: rotate(0deg);
  }

  .mobile-nav-accordion__arrow.is-child-open {
    transform: rotate(180deg) !important;
  }

  .mobile-nav-accordion__children {
    display: none;
    width: 100%;
    margin: 0;
    padding: 0;
    list-style: none;
  }

  .mobile-nav-accordion__children.is-open {
    display: block !important;
  }

  .mobile-nav-accordion__item.has-children .mobile-nav-accordion__link {
    cursor: pointer;
  }

  .mobile-nav-accordion__child-link {
    width: 100%;
    min-height: 40px;
    display: flex !important;
    align-items: center;
    gap: 10px;
    padding: 8px 18px 8px 72px !important;
    font-size: 14px;
    color: var(--black);
    text-decoration: none;
    box-sizing: border-box;
  }

  .mobile-nav-accordion__child-link.active {
    background: var(--orange_background) !important;
    border-left: 5px solid var(--orange) !important;
    padding-left: 67px !important;
  }
}
</style>
